import {MetaTagsProps, Blog} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {OG_PATH, appendCanonicalPath} from "@/content";

const heroImgSrc= '/images/blogs/blog1/hero/hero.jpg'
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {
    const slug = 'blog-1-slug'

    const metaTags : MetaTagsProps =  {
        title: "MetaBlog1Title",
        description: "MetaBlog1Description",
        keywords: "MetaBlog1Keywords",
        url: appendCanonicalPath(parentMetaTags.url, slug),
        ogImage: `${OG_PATH}${slug}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const blog: Omit<Blog, 'headCategory' | 'slug' | 'metaTags'> = {
    id: 1,
    title: 'Blog1Title',
    description: "Blog1Description",
    heroImage: {
        url: heroImgSrc,
        alt: 'Blog1HeroImageAlt',
        title: 'Blog1HeroImageTitle',
    },
    points: [],
    content,
    images,
}
